import React from 'react'
import Register from '../components/auth/Register'

const LoginPage = () => {
  return (
    <div><Register/></div>
  )
}

export default LoginPage